import { default as SimpleForm } from './wxSimpleForm';

export { SimpleForm };
